import bg from '../../Assets/images/bg.png';

function OnboardingBg() {
    return (
        <img src={bg} className='w-1/3' alt='POS' />
    )
}
export default OnboardingBg;